import * as React from "react";
import { useContext } from "react";
import { useFormikContext, Field } from "formik";
import styled from "styled-components";
import i18n from "i18n";
import { Trans, useTranslation } from "react-i18next";
import { Input, Alert } from "components/bootstrap";
import { validateField } from "util/FormsUtils";
import BackendWizardContext from "components/authentication/directoryServices/BackendWizard/BackendWizardContext";
import MatchingGroupsContext from "./MatchingGroupsContext";
const Groups = styled.div`
  display: flex;
  flex-wrap: wrap;
  border-radius: 2px;
  padding-top: 5px;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;
const SelectedGroup = styled.button(
  ({ theme }) => `
  display: flex;
  font-size: ${theme.fonts.size.small};
  color: ${theme.colors.gray[20]};
  padding: 0;
  margin-right: 5px;
  margin-bottom: 5px;
  border: 1px solid ${theme.colors.variant.lighter.info};
  border-radius: 2px;
  background-color: ${theme.colors.variant.lightest.info};
`
);
const SelectedGroupTitle = styled.div`
  padding: 2px 5px;
`;
const SelectedGroupRemove = styled.div(
  ({ theme }) => `
  border-left: 1px solid ${theme.colors.variant.lighter.info};
  display: flex;
  padding-left: 5px;
  padding-right: 5px;
  align-items: center;
`
);
const AllGroupsInfo = () => {
  const { t } = useTranslation("enterprise_authentication");
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, t("directory_services.selected_groups_overview.all_groups_info"));
};
const LoadingGroupsRequired = ({ selectionType }) => {
  const { t } = useTranslation("enterprise_authentication");
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, t("directory_services.selected_groups_overview.loading_groups_required", {
    selectionType: t(`directory_services.selected_groups_overview.selection_type_verbs.${selectionType}`)
  }));
};
const GroupSelectionRequired = ({ selectionType }) => {
  const { t } = useTranslation("enterprise_authentication");
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, t("directory_services.selected_groups_overview.group_selection_required", {
    selectionType: t(`directory_services.selected_groups_overview.selection_type_verbs.${selectionType}`)
  }));
};
const SelectedGroups = ({ matchingGroups, selectedGroupsIds, onGroupSelect }) => {
  const { t } = useTranslation("enterprise_authentication");
  return /* @__PURE__ */ React.createElement(Groups, null, selectedGroupsIds.toArray().map((groupId) => {
    const group = matchingGroups == null ? void 0 : matchingGroups.find((g) => g.id === groupId);
    return /* @__PURE__ */ React.createElement(SelectedGroup, { type: "button", onClick: () => onGroupSelect(groupId), key: groupId }, /* @__PURE__ */ React.createElement(SelectedGroupTitle, null, (group == null ? void 0 : group.title) || /* @__PURE__ */ React.createElement(
      Trans,
      {
        t,
        i18nKey: "directory_services.selected_groups_overview.group_not_found",
        values: { groupId },
        components: { b: /* @__PURE__ */ React.createElement("b", null) }
      }
    )), /* @__PURE__ */ React.createElement(SelectedGroupRemove, null, "\xD7"));
  }));
};
const _getLabel = (selectionType) => {
  switch (selectionType) {
    case "include":
      return i18n.t("directory_services.selected_groups_overview.label_include", { ns: "enterprise_authentication" });
    case "exclude":
      return i18n.t("directory_services.selected_groups_overview.label_exclude", { ns: "enterprise_authentication" });
    case "all":
    default:
      return i18n.t("directory_services.selected_groups_overview.label_selected", { ns: "enterprise_authentication" });
  }
};
const SelectedGroupsOverview = ({ onGroupSelect, validation }) => {
  const { setStepsState, ...stepsState } = useContext(BackendWizardContext);
  const { backendValidationErrors } = stepsState;
  const {
    values: { teamSelectionType }
  } = useFormikContext();
  const { result: loadGroupsResult } = useContext(MatchingGroupsContext);
  return /* @__PURE__ */ React.createElement(Field, { name: "teamSelection", validate: validateField(validation.teamSelection) }, ({ field: { value: teamSelection }, meta: { error } }) => /* @__PURE__ */ React.createElement(
    Input,
    {
      error: error != null ? error : backendValidationErrors == null ? void 0 : backendValidationErrors.teamSelection,
      id: "team-select",
      label: _getLabel(teamSelectionType),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(React.Fragment, null, teamSelectionType === "all" && /* @__PURE__ */ React.createElement(AllGroupsInfo, null), teamSelectionType !== "all" && !loadGroupsResult && /* @__PURE__ */ React.createElement(LoadingGroupsRequired, { selectionType: teamSelectionType }), teamSelectionType !== "all" && loadGroupsResult && (teamSelection == null ? void 0 : teamSelection.size) === 0 && /* @__PURE__ */ React.createElement(GroupSelectionRequired, { selectionType: teamSelectionType }), loadGroupsResult && (teamSelection == null ? void 0 : teamSelection.size) >= 1 && /* @__PURE__ */ React.createElement(
      SelectedGroups,
      {
        matchingGroups: loadGroupsResult == null ? void 0 : loadGroupsResult.list,
        onGroupSelect,
        selectedGroupsIds: teamSelection
      }
    ))
  ));
};
export default SelectedGroupsOverview;
